module.exports = __webpack_public_path__ + "img/giphy.59d9d392.gif";